<template>
  <v-map
    :style="defaultStyles"
    :class="defaultClass"
    :zoom="zoom"
    :minZoom="options.minZoom"
    :maxZoom="options.maxZoom"
    :center="center.icon"
    :options="options.options"
    style="z-index: 0; position: relative;"
  >
    <v-tilelayer :url="options.url" :attribution="options.attribution">
    </v-tilelayer>
    <slot name="squares" />
    <template v-if="coords.length > 0">
      <slot name="marker" />
    </template>
  </v-map>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";

export default {
  name: "Map",
  components: {
    vMap: Vue2Leaflet.LMap,
    vTilelayer: Vue2Leaflet.LTileLayer
  },
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          maxZoom: 18,
          minZoom: 6,
          url:
            "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          options: {}
        };
      }
    },
    center: {
      type: Object,
      required: true
    },
    coords: {
      type: Array,
      default: () => []
    },
    defaultClass: {
      type: String,
      default: ""
    },
    defaultStyles: {
      type: String,
      default: ""
    }
  },
  computed: {
    zoom() {
      return this.coords.length > 0 ? 14 : this.options.minZoom;
    }
  }
};
</script>
